export default __webpack_public_path__ + "trunk.3a871492.png";